<template>
    <div class="container d-flex justify-lg-space-around align-center flex-wrap">
        <a href="#" class="flex lg4 md4 sm4 xs4 d-flex justify-center partner_item"><img src="@/assets/images/logos/elements.png" alt=""></a>
        <a href="#" class="flex lg4 md4 sm4 xs4 d-flex justify-center partner_item"><img src="@/assets/images/logos/injoy.png" alt=""></a>
        <a href="#" class="flex lg4 md4 sm4 xs4 d-flex justify-center partner_item"><img src="@/assets/images/logos/injoy_xpress.png" height="120" alt=""></a>
    </div>
</template>

<script>
    export default {

    }
</script>

<style lang="sass" scoped>
    .container
        +r(599)
            text-align: center
            flex-wrap: nowrap
            justify-content: space-around
            padding: 0 10px
        .partner_item
          img
            max-width: 210px
            width: 100%
            height: auto
            +r(599)
                max-width: 90px
                width: auto
                display: block
</style>
